import { Outlet, useNavigate, useParams } from "react-router-dom";
import "../style.css";
import {
  Containerfull,
  HeaderMidImg,
  SiderContainer,
  Sider,
  Context,
  SiderNavBar,
} from "../../components/LayoutComponent";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { BreadCrumb, Row, Col, Button } from "./../../../ui/ot";
import { useBorrower } from "../../controllers/BorrowerController";
import { useTranslation } from 'react-i18next';

const Layout = ({ 
    keyPrefix = "library.backstage.Circulation.CheckOut",
    type 
}) => {
  const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
  const { itemnumber, borrowernumber } = useParams();
  const navigate = useNavigate();
  let iKey = 1;
  const SiderItem = [
    {
      key: iKey++,
      title: "home",
      href: "/library",
    },
    {
      key: iKey++,
      title: "BackStage",
      href: "/library/backstage",
    },
  ];

  iKey = 1;
  const CheckOutItem = [
    {
      key: iKey++,
      title: "Check Out",
      href: "CheckOut",
    },
    // {
    //   key: 2,
    //   title: "Detail",
    //   href: "PatronDetail",
    //   disabled:true
    // },
  ];

  iKey = 1;
  const BookDetail = [
    {
      key: iKey++,
      title: "一般",
      href: `BookDetail/${itemnumber}`,
    },
    {
      key: iKey++,
      title: "書籍",
      href: `BookDetailItems/${itemnumber}`,
    },
    {
      key: iKey++,
      title: "圖書預約",
      href: `BookDetailHolds/${itemnumber}`,
    },
  ];
  iKey = 1;
  const BorrowSiderItem = [
    {
      key: iKey++,
      title: "Circulation",
      href: `Circulation/`,
    },
    {
      key: iKey++,
      title: "Normal",
      //href: `BookDetail/${itemnumber}`
    },
    {
      key: iKey++,
      title: "MARC",
      //href: `BookDetailItems/${itemnumber}`
    },
    {
      key: iKey++,
      title: "ISBD",
      //href: `BookDetailHolds/${itemnumber}`
    },
    {
      key: iKey++,
      title: "Items",
      //href: `BookDetail/${itemnumber}`
    },
    {
      key: iKey++,
      title: "Holds",
      //href: `BookDetailItems/${itemnumber}`
    },
    {
      key: iKey++,
      title: "Article requests",
      //href: `BookDetailHolds/${itemnumber}`
    },
    {
      key: iKey++,
      title: "CheckOut history",
      //href: `BookDetail/${itemnumber}`
    },
    {
      key: iKey++,
      title: "Modification",
      //href: `BookDetailItems/${itemnumber}`
    },
    {
      key: iKey++,
      title: "Rota",
      //href: `BookDetailHolds/${itemnumber}`
    },
    {
      key: iKey++,
      title: "Recalls",
      //href: `BookDetailHolds/${itemnumber}`
    },
    ];
  iKey = 1
  const patronspermission = [
    {
        key :iKey++,
        title:"Data"
    },
    {
        key :iKey++,
        title:"Check out"
    },
    {
        key :iKey++,
        title:"Details"
    },
    {
        key :iKey++,
        title:"Accounting"
    },
    {
        key :iKey++,
        title:"Routing lists"
    },
    {
        key :iKey++,
        title:"Modification log"
    },
    {
        key :iKey++,
        title:"Notices"
    },
    {
        key :iKey++,
        title:"Statistics"
    },
    {
        key :iKey++,
        title:"Purchase\nsuggestions"
    },
  ]
  const SiderContext = () => {
    switch (type) {
      case "CheckOut":
        return (
          <Sider style={{ minWidth: "18em" }}>
            <CheckOutInfoBox>
              <InfoTitle>
                {borrower?.surname}({borrower?.cardnumber})
              </InfoTitle>
              <InfoLable>{t("address")}：{borrower?.B_address ?? "-"}</InfoLable>
              <InfoLable>{t("city")}：{borrower?.B_city ?? "-"}</InfoLable>
              <InfoLable>{t("phone")}：{borrower?.B_phone ?? "-"}</InfoLable>
              <InfoLable>{t("email")}：{borrower?.B_email ?? "-"}</InfoLable>
              <InfoLable>{t("birthday")}：{borrower?.dateofbirth ?? "-"}</InfoLable>
              <InfoLable>{t("type")}：{borrower?.categoryname ?? "-"}</InfoLable>
              <InfoLable>{t("affiliated_library")}：{borrower?.branchname ?? "-"}</InfoLable>
              <InfoLable>{t("patron_id")}：{borrower?.borrowernumber ?? "-"}</InfoLable>
              <InfoLable>{t("last_update_time")}：{borrower?.updated_on ?? "-"}</InfoLable>
            </CheckOutInfoBox>
            {CheckOutItem.map((e) => {
              console.log(e.href);
              return <SiderNavBar title={e.title} url={e.href} {...e} />;
            })}
          </Sider>
        );

      case "CirculationReserve":
        return (
          <Sider>
            <NavTitle>Default Sider</NavTitle>
            {BorrowSiderItem.map((e) => {
              return <SiderNavBar title={e.title} url={e.href} />;
            })}
          </Sider>
        );
      case "PatronPermissions":
        return (
          <Sider>
            <NavTitle>Permissions Sider</NavTitle>
            {patronspermission.map((e) => {
              return <SiderNavBar title={e.title} url={e.href} />;
            })}
          </Sider>
        );
      default:
        return (
          <Sider>
            <NavTitle>Default Sider</NavTitle>
                {SiderItem.map((e) => {
                    return <SiderNavBar key={e.key} title={e.title} url={e.href} />;
            })}
          </Sider>
        );
    }
  };

  const { BorrowerData, getBorrowerData } = useBorrower({
    onBefore: () => {},
    onFinish: () => {},
  });

  useEffect(() => {
    getBorrowerData({
      borrowernumber: borrowernumber,
    });
  }, [borrowernumber]);

  const borrower = BorrowerData?.find((_) => true);

  return (
    <Containerfull>
      <SiderContainer>
        <Sider>
          <SiderContext borrower={borrower} />
        </Sider>
        <Context>
          <div
            style={{
              padding: "2em",
            }}
          >
            <Row justify={"space-between"}>
              <Col>
                <BreadCrumb />
              </Col>
              <Col>
                <Button onClick={() => navigate(-1)}>{t("previous_step")}</Button>
              </Col>
            </Row>
            <Outlet />
          </div>
        </Context>
      </SiderContainer>
    </Containerfull>
  );
};

const NavTitle = styled.div`
  font-size: 1.5em;
  font-weight: 700;
  padding-left: 0.1em;
  color: #00000099;
`;

const CheckOutInfoBox = styled.div`
  padding: 1em 0.5em 1em 0.5em;
`;
const InfoTitle = styled.div`
  font-size: 1.2em;
`;
const InfoLable = styled.div`a

`;

const logo =
  "";

export default Layout;
